import { NavLink, Outlet } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuilding,
  faEnvelope,
  faDatabase,
} from '@fortawesome/free-solid-svg-icons';
import { ROUTES } from '@/routes/routes';

interface SettingsNavItem {
  label: string;
  to: string;
  icon: typeof faBuilding;
}

const NAV_ITEMS: SettingsNavItem[] = [
  { label: 'Company Settings', to: ROUTES.SETTINGS_COMPANY_PROFILE, icon: faBuilding },
  { label: 'Communication', to: ROUTES.SETTINGS_COMMUNICATION, icon: faEnvelope },
  { label: 'Report Storage', to: ROUTES.SETTINGS_REPORT_STORAGE, icon: faDatabase },
];

export function SettingsLayout() {
  return (
    <div className="flex min-h-0 gap-6">
      {/* Left nav */}
      <aside className="w-56 shrink-0">
        <div className="sticky top-6 rounded-xl border border-border bg-card p-2">
          <p className="mb-1 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Settings
          </p>
          <nav className="space-y-0.5" aria-label="Settings navigation">
            {NAV_ITEMS.map((item) => (
              <NavLink
                key={item.label}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm transition-colors ${
                    isActive
                      ? 'bg-primary/10 font-medium text-primary'
                      : 'text-foreground hover:bg-muted'
                  }`
                }
              >
                <FontAwesomeIcon icon={item.icon} className="h-3.5 w-3.5 shrink-0" />
                <span className="truncate">{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      </aside>

      {/* Content */}
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
}
